var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "moulding-options" },
    [
      _c("tab-heading", _vm._g({}, _vm.$listeners), [
        _c("h2", { staticClass: "text-center" }, [_vm._v("Choose a frame")]),
        _c("p", { staticClass: "lead text-center mb-0" }, [
          _vm._v("Filter and choose a moulding for your frame"),
        ]),
      ]),
      _c("moulding-search-filters", {
        staticClass: "mb-3",
        on: { "reset-filters": _vm.resetFilters },
        model: {
          value: _vm.options,
          callback: function ($$v) {
            _vm.options = $$v
          },
          expression: "options",
        },
      }),
      _c(
        "b-overlay",
        { attrs: { show: _vm.loading } },
        [
          _c(
            "p",
            { staticClass: "lead", attrs: { id: "moulding-result-container" } },
            [
              _vm._v(
                "Choose from " +
                  _vm._s(_vm.rows) +
                  " suitable Picture Frame Mouldings - Page " +
                  _vm._s(_vm.currentPage)
              ),
            ]
          ),
          _c("moulding-results", {
            ref: "results",
            staticClass: "mb-3",
            attrs: {
              mouldings: _vm.results,
              loading: _vm.loading,
              "non-frame-price": _vm.nonFramePrice,
            },
            model: {
              value: _vm.mouldingSelected,
              callback: function ($$v) {
                _vm.mouldingSelected = $$v
              },
              expression: "mouldingSelected",
            },
          }),
        ],
        1
      ),
      _c("b-pagination", {
        attrs: {
          align: "center",
          "total-rows": _vm.rows,
          "per-page": _vm.perPage,
        },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }